/// <reference path="../../../../Scripts/typings/toastr/toastr.d.ts" />
/// <reference path="../../../../Scripts/typings/q/Q.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/shopitemtemplate/viewmodels/index',["require", "exports", "models/breeze", "areas/shopitemtemplate/commands/writeshopitemtemplatecommand", "areas/shopitemtemplate/commands/editshopitemtemplatecommand", "common/viewmodelbase", "areas/shopitemtemplate/services/shopitemtemplaterepository", "areas/shopitemtemplate/services/mappings"], function (require, exports, Data, WriteShopItemTemplateCommand, EditShopItemTemplateCommand, common, repository, mappings) {
    "use strict";
    var IndexViewModel = (function (_super) {
        __extends(IndexViewModel, _super);
        // #region ctor
        function IndexViewModel() {
            _super.call(this);
            this.shopItemTemplates = new repository.ShopItemTemplateRepository();
            this.title = $.t("app:modules.shopitemtemplate.headline_title", { ifMissing: "Verwaltung der ShopItemTemplates" });
            ko.track(this, ["name", "filterName"]);
            ko.getObservable(this, "name").extend({ rateLimit: 500 });
        }
        // #endregion
        // #region overrides
        //    public onActivated(context: Portal.ApplicationContext) {
        IndexViewModel.prototype.onActivated = function (context) {
            if (this.controller == null) {
                this.controller = new Data.BreezeDataController(this.shopItemTemplates, null, false).configure(function (result) { return result.map(function (s) { return mappings.mapShopItemTemplateFromDTO(s); }); });
                return Q.when(this.initialize());
            }
            // return null;
        };
        // #endregion
        IndexViewModel.prototype.initialize = function () {
            this.setUpController();
            this.attachEvents();
            //this.deleteCommand = new DeleteShopItemTemplatesCommand(this.taskManager, () => this.controller.load());
            this.editCommand = new EditShopItemTemplateCommand();
            this.writeCommand = new WriteShopItemTemplateCommand();
        };
        IndexViewModel.prototype.attachEvents = function () {
            var _this = this;
            ko.getObservable(this, "name").subscribe(function (value) {
                _this.controller.filterDefinitions.replace(Data.BreezeColumnFilter.contains("Name", value));
            });
        };
        IndexViewModel.prototype.setUpController = function () {
        };
        return IndexViewModel;
    }(common.ListViewModelBase));
    return IndexViewModel;
});

